import React, {useEffect, useState} from 'react'
import '../regulationAcceptance/RegulationAcceptance.css';
import { useDispatch, useSelector } from 'react-redux';
import { acceptTerms, fetchTerms,getTermsForSalesWarranty,getTermsForWarranty } from '../../features/regulation/RegulationAcceptanceSlice';
import { setIsTermOfUseAccepted } from '../../features/complaint/ComplaintSlice';
import { setTermOfUse } from '../../features/complaintPosition/ComplaintPositionSlice';



const RegulationAcceptance = ({ onChange, checked, selectedOption }) => {
  const isTermOfUseAccepted = useSelector((state) => state.complaint.isTermOfUseAccepted);
  const complaintTypes = useSelector((state) => state.complaint.complaintType.name);

  const dispatch = useDispatch();

  const handleOnChange = () => {
    dispatch(setIsTermOfUseAccepted(!isTermOfUseAccepted));
    dispatch(setTermOfUse(true));
  };

  const handleUncheckTerms = () => {
    dispatch(setIsTermOfUseAccepted(false));
  };

  const handleOpenTerms = () => {
    let termOfUse;

    switch (complaintTypes) {
      case 'SalesWarranty':
        termOfUse = 'https://firma-pro.com/media/wysiwyg/do-pobrania/gwarancje/2022/Regulamin_gwarancja_PRO_2022.pdf';
        break;

      case 'PayedRepair':
        termOfUse = 'https://firma-pro.com/media/wysiwyg/do-pobrania/gwarancje/Regulamin_odpl_uslug_serwis_082022.pdf';
        break;

      case 'PostWarrantyLaserDeviceCalibration':
        termOfUse = 'https://firma-pro.com/media/wysiwyg/do-pobrania/gwarancje/Regulamin_odpl_uslug_serwis_082022.pdf';
        break;

      case 'UnderWarrantyLaserDeviceCalibration':
        termOfUse = 'https://firma-pro.com/media/wysiwyg/do-pobrania/gwarancje/2022/Regulamin_gwarancja_PRO_2022.pdf';
        break;

      case 'Warranty':
        termOfUse = 'https://firma-pro.com/media/wysiwyg/do-pobrania/gwarancje/2022/Regulamin_rekojmia_PRO_2022.pdf';
        break;

      case 'DeliveryMismatch':
        termOfUse = 'https://firma-pro.com/media/wysiwyg/do-pobrania/gwarancje/2022/OWS_PRO_2022.pdf'
        break;
      
      case 'TransportDamage':
        termOfUse = 'https://firma-pro.com/media/wysiwyg/do-pobrania/gwarancje/2022/OWS_PRO_2022.pdf'
        break;
      default:
        break;
    }

    return termOfUse;
  };


  return (
    <div>
      <label>
        <input type="checkbox" checked={isTermOfUseAccepted} onChange={handleOnChange} onClick={handleUncheckTerms} />
        <a className="terms" style={{ position: 'relative', top: '0%', padding: '0px', letterSpacing: '1px' }}>
          Znam i akceptuję <a href={handleOpenTerms()} className="terms" target="_blank" rel="noopener noreferrer" style={{ position: 'relative', top: '0%' }}><b><u>Regulamin</u></b></a> serwisowania i naprawy urządzeń
        </a>
        {!isTermOfUseAccepted && <p className="error" style={{ marginTop: '0px' }}>Proszę zaakceptować regulamin</p>}
      </label>
    </div>
  );
};

export default RegulationAcceptance;